import { ActionButton as e } from "./ComposerAction.styled.mjs";
import "react";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/Composer/components/ComposerAction.tsx
var n = ({ label: n, children: r, ...i }) => /* @__PURE__ */ t(e, {
	type: "button",
	"aria-label": n,
	...i,
	children: r
});
//#endregion
export { n as ComposerAction };
